<template lang="pug">
GenericCard.sell-record-panel(size='33')
  FancyHeader(
    title='รายการขายที่ได้'
    :backgroundSrc='require(`@/assets/profile-performance/header-background-sell-record.png`)'
  )
  .d-flex.py-3.px-4
    CustomDatePicker.text-large.mx-auto(v-model='filterDate')
  hr.m-0
  .d-flex.py-3.px-4
    CustomSearchBox.w-100(v-model='filterSearch' placeholder='ค้นหาด้วยเลขที่รายการ' width='100%')
      i.fa.fa-search
  hr.m-0

  modal(
    name='sell-record'
    width='90%' height='95%'
    transition='modal-transition'
  )
    SellRecordDetail(
      :customer='selectedCustomer'
      :sellRecord='selectedItem'
      @closeButtonClicked='hideModal'
      :isLoading='isLoading'
    )

  LoadedContentWrapper(
    :isLoading='isLoading'
    :data='listData'
    @reload='loadData'
  )
    .sell-record-list.scrollable
      template(v-for='entry in filteredData')
        .transparent-button.no-scaling(@click="showModal(entry)")
          .px-4.mx-2.py-3
            .text-17 {{ entry.customer.name }}

            .d-flex.mt-1
              .text-17.w-50
                | {{ entry.unix_id }}
              .text-17.w-50
                | {{ formatDate(entry.created_at) }}

            .d-flex.mt-3
              div.w-50
                .text-small ค่าคอมมิชชั่นที่ได้
                .text-19.red.bold {{ entry.total_commission | currency }}
              div.w-50
                .text-small ยอดบิลรวม
                .text-19.red.bold {{ entry.total_sale | currency }}

            //- div {{ JSON.stringify(entry) }}
          hr.m-0
</template>

<script>
import FancyHeader from '@/components/profile-performance/FancyHeader.vue';
import SellRecordDetail from '@/components/history/dialogs/SellRecord/SellRecordDetail.vue';

export default {
  components: {
    FancyHeader,
    SellRecordDetail,
  },
  data: () => ({
    filterDate: '',
    filterSearch: '',
    listData: [
      // {
      //   name: 'บริษัท ซาฟารีเวิลด์ จำกัด (มหาชน)',
      //   entryNo: 'AB636789090',
      // },
    ],

    selectedCustomer: {},
    selectedItem: {},

    isLoading: false,
  }),
  watch: {
    // reload data
    filterDate: {
      deep: true,
      handler() { this.loadData(); },
    },
    filterSearch() { this.loadData(); },
  },
  mounted() {
    this.loadData();
  },
  computed: {
    filteredData() {
      // const KEYWORD = this.filterSearch.toUpperCase();
      // return this.listData.filter(item => (KEYWORD === '') || (
      //   item.unix_id.toUpperCase().includes(KEYWORD)
      // ));
      return this.listData;
    },
  },
  methods: {
    showModal(e) {
      this.selectedItem = e;
      this.selectedCustomer = e.customer;
      this.$modal.show('sell-record');
    },
    hideModal() {
      // console.log('close');
      this.$modal.hide('sell-record');
      this.loadData();
    },
    async loadData() {
      this.isLoading = true;

      this.listData = null;
      try {
        const res = await this.$api.user.recentSalesList(this.filterDate, this.filterSearch);
        if (res.status === 200) {
          this.listData = res.data;
        }
      } catch (e) {
        this.listData = null;
      }

      this.isLoading = false;
    },
    formatDate(dateString) {
      return this.$moment(dateString).format('DD/MM/YYYY');
    },
  },
};
</script>

<style lang="scss">
.sell-record-panel {
  .sell-record-list {
    min-height: 80px;
  }
}
</style>
